module.exports = __webpack_public_path__ + "media/images/athletes/2923-db62887ac0239959191e0211ff6216fb.png";